var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file"},_vm._l((_vm.fileResult),function(file,index){return _c('div',{key:index,staticClass:"card-item",on:{"click":function($event){return _vm.handleReturnPdf(file.fullFileName)}}},[_c('i',{staticClass:"pdf"}),_c('span',{domProps:{"innerHTML":_vm._s(file.fileName)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }